'use client';

import dynamic from 'next/dynamic';

export type { ImageCropModalProps } from './ImageCropModalClient';

export const ImageCropModal = dynamic(() => import('./ImageCropModalClient'), {
  ssr: false,
});
